import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Bono 1 — 10 Casos Clínicos Resueltos',
  desc: 'Aplica la teoría a casos reales de guardia.'
}, {
  title: 'Bono 2 — Banco de Radiografías Comentadas',
  desc: 'Aprende a ver lo que los expertos ven.'
}, {
  title: 'Bono 3 — Algoritmo de Guardia Nocturna',
  desc: 'Decisiones rápidas a las 3 AM.'
}, {
  title: 'Bono 4 — Checklist de Procedimientos del R1',
  desc: 'No te olvides de ningún paso crítico.'
}, {
  title: 'Bono 5 — Protocolo de Presentación de Caso',
  desc: 'Lucite en el pase de sala matutino.'
}];
export function Bonuses() {
  return <section className="py-20 bg-pastel-50 px-4" data-id="element-14">
      <div className="max-w-4xl mx-auto" data-id="element-15">
        <div className="text-center mb-12" data-id="element-16">
          <div className="inline-block bg-red-100 text-red-700 font-bold px-4 py-1.5 rounded-full text-sm mb-4 animate-pulse" data-id="element-17">
            GRATIS POR HOY
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-18">
            Llevate estos 5 bonos exclusivos
          </h2>
          <p className="text-slate-600" data-id="element-19">
            Complementos diseñados específicamente para acelerar tu curva de
            aprendizaje.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-20">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white border border-pastel-200 p-5 rounded-xl shadow-sm hover:shadow-md transition-all hover:-translate-y-1 flex items-start gap-4 ${i === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-21">
              <div className="bg-gold-100 text-gold-600 p-3 rounded-lg shrink-0" data-id="element-22">
                <Gift size={24} data-id="element-23" />
              </div>
              <div data-id="element-24">
                <h3 className="font-bold text-navy-900 mb-1" data-id="element-25">{bono.title}</h3>
                <p className="text-sm text-slate-500" data-id="element-26">{bono.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}